import React from 'react';
export function AdvisoryFooter() {
  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if (href && href.startsWith('#')) {
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <footer className="w-full py-12 px-6 sm:px-8 lg:px-16 bg-slate-950 border-t border-slate-800" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-8" data-id="element-63">
          <div className="flex items-center gap-6" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/xiJX1BNGuywsLcQCuy8Sr8/ironsmith_advisors_logo.png" alt="Ironsmith Advisors" className="h-10 w-auto opacity-80" data-id="element-65" />
            <div className="h-8 w-px bg-slate-800" data-id="element-66" />
            <p className="text-slate-500 text-sm" data-id="element-67">
              Institutional-grade finance for the modern SMB.
            </p>
          </div>

          <nav className="flex flex-wrap gap-6 text-sm" data-id="element-68">
            <a href="#services" onClick={handleSmoothScroll} className="text-slate-500 hover:text-white transition-colors" data-id="element-69">
              Services
            </a>
            <a href="#case-studies" onClick={handleSmoothScroll} className="text-slate-500 hover:text-white transition-colors" data-id="element-70">
              Results
            </a>
            <a href="#faq" onClick={handleSmoothScroll} className="text-slate-500 hover:text-white transition-colors" data-id="element-71">
              FAQ
            </a>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-72">
          <p className="text-slate-600 text-xs" data-id="element-73">
            © {new Date().getFullYear()} Ironsmith Capital Advisory. All rights
            reserved.
          </p>
          <p className="text-slate-600 text-xs" data-id="element-74">
            CFA® is a registered trademark of the CFA Institute.
          </p>
        </div>
      </div>
    </footer>;
}